var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loadingDetail
    ? _c(
        "div",
        { staticClass: "eu-pa_6 eu-align_center" },
        [_c("emd-loader", { attrs: { type: "_invert" } })],
        1
      )
    : _c(
        "div",
        { staticClass: "el-stripe" },
        [
          _c("div", { staticClass: "el-section" }, [
            _c("div", { staticClass: "el-grid-list" }, [
              _c("div", { staticClass: "emd-container" }, [
                _c("div", {
                  staticClass: "emd-status-bar",
                  class: _vm.statusClass(_vm.invoice.status),
                }),
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("invoice.detail.status")) + " "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "emd-badge",
                      class: _vm.statusClass(_vm.invoice.status),
                    },
                    [_vm._v(_vm._s(_vm.invoice.status))]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("invoice.detail.amount")) + " "
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(_vm._s(_vm.invoice.amount)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("invoice.detail.payment-method")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(_vm._s(_vm.invoice.payment_method)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("invoice.detail.due-at")) + " "
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormat")(_vm.invoice.due_at, "date")
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "el-section" }, [
            _c("div", { staticClass: "emd-container _highlight_header" }, [
              _c("div", { staticClass: "emd-container__header" }, [
                _c("h2", { staticClass: "emd-text _size_section" }, [
                  _vm._v(" " + _vm._s(_vm.$t("invoice.detail.info")) + " "),
                ]),
              ]),
              _c("div", { staticClass: "emd-container__content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("invoice.detail.general-data")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("invoice.detail.id")) + " "
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.invoice.id))]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("invoice.detail.code")) + " "
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.invoice.code))]),
                      ]),
                      Object.entries(_vm.invoice.subscription).length
                        ? _c(
                            "div",
                            { staticClass: "el-chunk" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _color_subtle _type_label _size_tiny",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("invoice.detail.origin")) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.permissionIsEnabled("subscription:get")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "emd-link",
                                      attrs: {
                                        to: {
                                          name: "subscriptionsDetail",
                                          params: {
                                            id: _vm.invoice.subscription.id,
                                            tab: "info",
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.invoice.subscription.id)
                                      ),
                                    ]
                                  )
                                : _c("p", { staticClass: "emd-text" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.invoice.subscription.id || "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.invoice.installments
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _color_subtle _type_label _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("invoice.detail.installments")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.invoice.installments)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.invoice.metadata &&
                      Object.entries(_vm.invoice.metadata).length
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _color_subtle _type_label _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("invoice.detail.more-info")) +
                                    " "
                                ),
                              ]
                            ),
                            _c("pre", [_vm._v(_vm._s(_vm.invoice.metadata))]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("invoice.detail.customer.title")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c(
                        "div",
                        { staticClass: "el-chunk" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "emd-text _color_subtle _type_label _size_tiny",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("invoice.detail.customer.name")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.permissionIsEnabled("customer:get")
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "emd-link",
                                  attrs: {
                                    to: {
                                      name: "customersDetail",
                                      params: {
                                        id: _vm.invoice.customer.id,
                                        tab: "info",
                                      },
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.invoice.customer.name || "-")
                                  ),
                                ]
                              )
                            : _c("p", { staticClass: "emd-text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.invoice.customer.name || "-") +
                                    " "
                                ),
                              ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("invoice.detail.customer.email")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.invoice.customer.email || "-")),
                        ]),
                      ]),
                      _vm.invoice.customer.phones &&
                      _vm.invoice.customer.phones.home_phone
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("invoice.detail.customer.phone")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.invoice.customer.phones.home_phone
                                    .country_code
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.invoice.customer.phones.home_phone
                                      .area_code
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.invoice.customer.phones.home_phone
                                      .number
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.invoice.customer.phones &&
                      _vm.invoice.customer.phones.mobile_phone
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "invoice.detail.customer.mobile-phone"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.invoice.customer.phones.mobile_phone
                                    .country_code
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.invoice.customer.phones.mobile_phone
                                      .area_code
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.invoice.customer.phones.mobile_phone
                                      .number
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.invoice.customer.address
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _color_subtle _type_label _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("invoice.detail.customer.address")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.invoice.customer.address.street) +
                                  " " +
                                  _vm._s(_vm.invoice.customer.address.number) +
                                  " - " +
                                  _vm._s(
                                    _vm.invoice.customer.address.complement
                                  ) +
                                  " - " +
                                  _vm._s(
                                    _vm.invoice.customer.address.neighborhood
                                  ) +
                                  ", " +
                                  _vm._s(_vm.invoice.customer.address.city) +
                                  ", " +
                                  _vm._s(_vm.invoice.customer.address.state) +
                                  " - " +
                                  _vm._s(_vm.invoice.customer.address.country) +
                                  " "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "el-section" }, [
            _c("div", { staticClass: "emd-container _highlight_header" }, [
              _c("div", { staticClass: "emd-container__header" }, [
                _c("h2", { staticClass: "emd-text _size_section" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("invoice.detail.items.title")) + " "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "emd-table-responsive" },
                [
                  _c("Table", {
                    attrs: { fields: _vm.fields, items: _vm.invoice.items },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm.invoice.charge
            ? _c("div", { staticClass: "el-section" }, [
                _c("div", { staticClass: "emd-container _highlight_header" }, [
                  _c("div", { staticClass: "emd-container__header" }, [
                    _c("h2", { staticClass: "emd-text _size_section" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("invoice.detail.charge.title")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "emd-card-grid" }, [
                    _c("div", { staticClass: "emd-card-grid__content" }, [
                      _c("div", { staticClass: "eu-clearfix" }, [
                        _c("div", { staticClass: "eu-float_left" }, [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "emd-text _type_caption _size_section eu-pb_2 eu-pr_2 eu_no_padding_sm",
                            },
                            [
                              _vm.permissionIsEnabled("charge:get")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "emd-link",
                                      attrs: {
                                        to: {
                                          name: "chargesDetail",
                                          params: { id: _vm.invoice.charge.id },
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.invoice.charge.id))]
                                  )
                                : _c("p", { staticClass: "emd-text" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.invoice.charge.id || "-") +
                                        " "
                                    ),
                                  ]),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "eu-float_left_mobile eu-float_right",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "emd-badge",
                                class: _vm.statusClass(
                                  _vm.invoice.charge.status
                                ),
                              },
                              [_vm._v(_vm._s(_vm.invoice.charge.status))]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-card-grid__row" }, [
                      _c("div", { staticClass: "emd-card-grid__column" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "emd-text _type_label _size_tiny _color_subtle",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("invoice.detail.charge.amount"))
                            ),
                          ]
                        ),
                        _c("p", { staticClass: "emd-card-grid__line" }, [
                          _vm._v(_vm._s(_vm.invoice.charge.amount)),
                        ]),
                      ]),
                      _vm.invoice.charge.paid_at
                        ? _c("div", { staticClass: "emd-card-grid__column" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "emd-text _type_label _size_tiny _color_subtle",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("invoice.detail.charge.paid-at")
                                  )
                                ),
                              ]
                            ),
                            _vm.invoice.charge.payment_method === "Boleto"
                              ? _c(
                                  "p",
                                  { staticClass: "emd-card-grid__line" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            _vm.invoice.charge.paid_at,
                                            "date"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "p",
                                  { staticClass: "emd-card-grid__line" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            _vm.invoice.charge.paid_at,
                                            "dateAndHour"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                          ])
                        : _vm._e(),
                      _vm.invoice.charge.due_at
                        ? _c("div", { staticClass: "emd-card-grid__column" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "emd-text _type_label _size_tiny _color_subtle",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("invoice.detail.charge.due-at"))
                                ),
                              ]
                            ),
                            _c("p", { staticClass: "emd-card-grid__line" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm.invoice.charge.due_at,
                                      "date"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "emd-card-grid__column" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "emd-text _type_label _size_tiny _color_subtle",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("invoice.detail.charge.payment-method")
                              )
                            ),
                          ]
                        ),
                        _c("p", { staticClass: "emd-card-grid__line" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.invoice.charge.payment_method) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "emd-card-grid__column" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "emd-text _type_label _size_tiny _color_subtle",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("invoice.detail.charge.created-at"))
                            ),
                          ]
                        ),
                        _c("p", { staticClass: "emd-card-grid__line" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  _vm.invoice.charge.created_at,
                                  "dateAndHour"
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("log-links", {
            attrs: { entity: _vm.invoice, title: _vm.$t("log-links.invoice") },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }